<template>
  <div>
    <el-form-item :label="$t('默认值')">
        <l-select  
                v-model="data.default"
                :placeholder="$t('请选择')" 
                size="mini"
                :options="myOptions"
            >
        </l-select>
    </el-form-item>
    <el-divider>{{$t('选项')}}</el-divider>
    <div style="text-align: center;margin-bottom:16px;" >
        <el-radio-group v-model="data.dataType" size="mini" @change="handleDataTypeChange" >
            <el-radio-button label="1">{{$t('静态数据')}}</el-radio-button>
            <el-radio-button label="2">{{$t('数据字典')}}</el-radio-button>
            <el-radio-button label="3">{{$t('数据源')}}</el-radio-button>
            <el-radio-button label="4">{{$t('接口')}}</el-radio-button>
        </el-radio-group>
    </div>
    <!--静态数据-->
    <div v-if="data.dataType == 1" >
        <draggable
            :list="data.options"
            :group="{ name: 'dic' }"
            ghost-class="set-item-ghost"
            handle=".drag-item">
            <div v-for="(item, index) in data.options"
                class="set-item"
                :key="index">
            <i class="drag-item el-icon-rank"></i>
            <el-input
                style="width:49%;margin-right:2%;"
                size="mini"
                v-model="item.label"
                :placeholder="$t('选项名')"></el-input>
            <el-input
                style="width:49%;"
                size="mini"
                v-model="item.value"
                :placeholder="$t('选项值')"></el-input>
            <el-button 
                v-if="data.options.length > 1"
                @click="handleRemoveDatas(index)"
                circle
                plain
                type="danger"
                size="mini"
                icon="el-icon-minus"
                class="delete-item"
                style="padding: 4px;"></el-button>
            </div>
        </draggable>
        <div style="padding-left:22px;" >
            <el-button size="mini" type="text" icon="el-icon-circle-plus-outline" @click="handleAddDatas"  >{{$t('添加选项卡')}}</el-button>
        </div>
    </div>
    <!--数据字典-->
    <div v-else-if="data.dataType == 2" >
        <l-tree-select
            v-model="data.dataCode"
            :options="dataItemClassifysTree"
            :placeholder="$t('请选择')"
            size="mini"
            :parent="false"

            @change="handleDataItemChange"
        >
        </l-tree-select>
    </div>
    <!--远端数据-->
    <div v-else-if="data.dataType == 3" >
        <el-form-item :label="$t('数据源')">
            <l-select  
                    v-model="data.dataCode"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="dataSource" 
                    labelKey="f_Name" 
                    valueKey="f_Code"

                    @change="handleDataSourceChange"
                >
            </l-select>
        </el-form-item>
        <div v-if="data.ParamJsonList && data.ParamJsonList.length" style="margin-bottom: 10px;">参数</div>
        <currencyCustomSearch :ParamJsonList="data.ParamJsonList" @getList="getList" :showReset="false" :viewMode="true" ref="customSearch" :searchText="'刷新数据'"></currencyCustomSearch>
        <el-form-item :label="$t('值')">
            <l-select  
                    v-model="data.dataValueKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList" 

                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('标签')">
            <l-select  
                    v-model="data.dataLabelKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList"
                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('上一级')">
            <l-select
                v-model="data.upCtrl"
                :placeholder="$t('请选择')"
                size="mini"
                :options="componentOptions"
            >
            </l-select>
        </el-form-item>
        
    </div>
    <div v-else>
        <el-form-item :label="$t('接口地址')">
            <el-input
            size="mini"
            v-model="data.httpUrl"
            :placeholder="$t('请输入接口地址')"
            @change="changeURL"></el-input>
        </el-form-item>
        <el-form-item :label="$t('请求方式')">
            <l-select  
                v-model="data.httpWay"
                :placeholder="$t('请选择')" 
                size="mini" 
                :options="wayList"
                labelKey="label" 
                valueKey="value"
                @change="changeURL"
            >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('请求默认参数')">
            <el-input
            type="textarea"
            size="mini"
            v-model="data.params"
            :placeholder="$t('请输入请求默认参数')"
            @change="changeURL"></el-input>
        </el-form-item>
        <el-form-item :label="$t('搜索参数')">
            <el-input
            size="mini"
            v-model="data.remoteParams"
            :placeholder="$t('请输入请求参数')"
            @change="changeURL"></el-input>
        </el-form-item>
        <el-form-item :label="$t('关联组件ID')">
            <el-input
            type="textarea"
            size="mini"
            v-model="data.assemblyID"
            :placeholder="$t('请输入关联组件ID,多个逗号分隔')"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('请求参数')">
            <el-input
            type="textarea"
            size="mini"
            v-model="data.params"
            :placeholder="$t('请输入请求参数')"
            @change="changeURL"></el-input>
        </el-form-item>
        <el-form-item :label="$t('搜索参数')">
            <el-input
            size="mini"
            v-model="data.remoteParams"
            :placeholder="$t('请输入请求参数')"
            @change="changeURL"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('值')">
            <l-select  
                    v-model="data.dataValueKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myRemoteList" 

                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('标签')">
            <l-select  
                    v-model="data.dataLabelKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myRemoteList"
                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
    </div>
    
    <el-divider></el-divider>
    <el-form-item :label="$t('是否只读')">
        <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否必填')">
        <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
  </div>
</template>

<script>
import mixin from '../../../mixin'
export default {
    name: "config-select",
    mixins: [mixin()],
    inject: ["formDesign"],
    props: ['data'],
    data () {
        return {
            wayList:[
                {label:'GET',value:'GET'},
                {label:'POST',value:'POST'},
                {label:'PUT',value:'PUT'},
                {label:'DELETE',value:'DELETE'},
            ]
        }
    },
    created(){
        this.lr_loadDataItemClassifys && this.lr_loadDataItemClassifys()
        this.lr_loadDataSourceList && this.lr_loadDataSourceList()
        this.loadDataSourceCol()
    },
    computed:{
        dataItemClassifysTree(){
            if(this.lr_dataItemClassifysTree){
                return this.lr_dataItemClassifysTree
            }
            else{
                return []
            }
        },
        dataSource(){
            if(this.lr_dataSource){
                return this.lr_dataSource
            }
            else{
                return []
            }
        }
    },
    methods: {
        changeURL(){
            if(this.data.httpWay&&this.data.httpUrl){
                this.lr_loadDataByURL(this.data.httpUrl,this.data.httpWay,this.data.params)
            }
        },
        handleDataTypeChange(){
            this.data.dataCode = '';
            this.data.dataValueKey = '';
            this.data.dataLabelKey = '';


            this.data.default = '';
            if (this.data.dataType !== 3) {
                this.data.seachLoopUp = false
            }
        },
        handleAddDatas(){
            this.data.options.push({label:'选项' + (this.data.options.length + 1) ,value: String(this.data.options.length + 1)});
        },
        handleRemoveDatas(index){
            if(this.data.default == this.data.options[index].value){
                this.data.default = '';
            }
            this.data.options.splice(index,1);
        },

        handleDataItemChange(){
            this.data.default = ''
            if(!this.$validatenull(this.data.dataCode) && this.lr_loadDataItem){
                this.lr_loadDataItem(this.data.dataCode)
            }
        },
        handleDataSourceChange(data){
            this.data.default = ''
            this.data.dataValueKey = ''
            this.data.dataLabelKey = ''
            let sql = data.f_Sql;
            const { columns, queryJson, sqls } = JSON.parse(sql);
            var obj = {}
            if (queryJson) {
                queryJson.forEach(item => {
                    item.disabled = item.f_DefaultValue ? item.f_DefaultValue.charAt(0) == '#' ? true : false : false
                    var bol = true
                    if(this.lr_dataParamsSource){
                      for(var i in this.lr_dataParamsSource){
                        if(i == item.f_DefaultValue){
                            obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                            bol= false
                        }else{
                          if(bol){
                            if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                              obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                            }else{
                              obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                            }
                          }
    
                        }
                      }
                    }else{
                      if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                        obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                      }else{
                        obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                      }
                    }
                })
                this.data.ParamJsonList = queryJson
            } else {
                this.data.ParamJsonList = []
            }
            var pamdata = {
                queryJson:obj
            }
            if(!this.$validatenull(this.data.dataCode) && this.lr_loadDataSourceColNames){
                this.lr_loadDataSourceColNames(this.data.dataCode)
                this.lr_loadDataSourceDataByParamter(this.data.dataCode,pamdata, true, true)
            }
        },
        getList(list){
            this.data.dataValueKey = '';
            this.data.dataLabelKey = '';
            this.data.default = '';
            this.data.ParamJsonList = list
            var obj = {}
            list.forEach((item) => {
                var bol = true
                if(this.lr_dataParamsSource){
                    for(var i in this.lr_dataParamsSource){
                    if(i == item.f_DefaultValue){
                        obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                        bol= false
                    }else{
                        if(bol){
                        if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                            obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                        }else{
                            obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                        }
                        }

                    }
                    }
                }else{
                    if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                    obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                    }else{
                    obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                    }
                }
            })
            var pamdata = {
                queryJson:obj
            }
            this.lr_loadDataSourceDataByParamter(this.data.dataCode,pamdata, true, true)
        },
        handleDataSourceKeyLabelChange(){
            this.data.default = ''
        }
    }
}
</script>

